import { render } from "./kalio-startup-application-update-form.vue?vue&type=template&id=694b45f6"
import script from "./kalio-startup-application-update-form.vue?vue&type=script&lang=js"
export * from "./kalio-startup-application-update-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__